"use strict";
exports.__esModule = true;
exports.decode = void 0;
var function_1 = require("fp-ts/lib/function");
var TaskEither_1 = require("fp-ts/lib/TaskEither");
var Either_1 = require("../Either");
var decode = function (T, data) {
    return function_1.pipe(Either_1.decode(T, data), TaskEither_1.fromEither);
};
exports.decode = decode;
